import axios, { InternalAxiosRequestConfig, isAxiosError } from "axios";
import { handleApiError } from "../utils/apiErrorHandler";
import router from "@/router";

/** Rutas de auth que pueden responder 401 sin invalidar la sesión del panel (credenciales incorrectas, etc.) */
function isPublicAuthEndpoint(config: InternalAxiosRequestConfig | undefined): boolean {
  if (!config?.url) return false;
  const path = (config.url.split("?")[0].startsWith("/")
    ? config.url.split("?")[0]
    : `/${config.url.split("?")[0]}`
  ).toLowerCase();
  return /\/auth\/(login|register|forgotpassword|resetpassword|validate-reset-token)(\/|$)/.test(
    path
  );
}

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false, 
});

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("access_token");
    
 
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
      
    }

    if (config.data instanceof FormData) {
      delete config.headers?.["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta global
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, message } = handleApiError(
      error,
      "Error al comunicarse con el servidor"
    );

    if (
      status === 401 &&
      isAxiosError(error) &&
      !isPublicAuthEndpoint(error.config)
    ) {
      void import("@/stores/authStore").then(({ useAuthStore }) => {
        const auth = useAuthStore();
        auth.logout();
        if (router.currentRoute.value.path !== "/") {
          void router.push("/");
        }
      });
    }

    return Promise.reject({ status, message });
  }
);

export default apiClient;